import Keycloak from 'keycloak-js'

const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL ?? 'http://localhost:8180',
  realm: import.meta.env.VITE_KEYCLOAK_REALM ?? 'trading',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? 'trading-frontend',
})

let initialized = false

export async function initKeycloak(): Promise<boolean> {
  if (initialized) return keycloak.authenticated ?? false
  initialized = true

  const authenticated = await keycloak.init({
    onLoad: 'login-required',
    checkLoginIframe: false,
    pkceMethod: 'S256',
  })

  // Auto-refresh token when it will expire in less than 60 seconds
  setInterval(() => {
    keycloak.updateToken(60).catch(() => {
      keycloak.logout()
    })
  }, 30_000)

  return authenticated
}

export function getToken(): string | undefined {
  return keycloak.token
}

export function logout(): void {
  keycloak.logout()
}

export function getTenantId(): string {
  const parsed = keycloak.tokenParsed as Record<string, unknown> | undefined
  return (parsed?.['tenant_id'] as string) ?? ''
}

export default keycloak
